import { ArticleLocationObservationStatus } from "types";

export const resolveObservationStatusFromRowStatus = (
  status?: unknown,
): ArticleLocationObservationStatus =>
  status === "not_available" || status === "unavailable"
    ? "not_available"
    : "available";

export const getObservationStatusLabel = (status?: unknown): string =>
  resolveObservationStatusFromRowStatus(status) === "not_available"
    ? "Mercaderia no disponible"
    : "Mercaderia disponible";

export const getObservationValueByStatus = (
  value: unknown,
  status: ArticleLocationObservationStatus,
): string => {
  if (typeof value === "string") {
    return status === "available" ? value : "";
  }

  if (value && typeof value === "object" && !Array.isArray(value)) {
    const candidate = (value as Record<string, unknown>)[status];
    return typeof candidate === "string" ? candidate : "";
  }

  return "";
};
